'use strict'

import { state } from '@domql/mixins'
export default state
